import IResult from "../../models/result/IResult";
import ConversationSessionState from "../../models/sessionAttributes/ConversationSessionState";
import { getAssistantApiUrl } from "../../constants/Urls";
import { sendPost, sendGet } from "./generic";

export const getSessionAttributes = (sessionId: string, applicationId: string, applicationSecret:string): Promise<IResult<ConversationSessionState>> => {
    return sendGet(`/UserProfile/session/${sessionId}?applicationId=${applicationId}&applicationSecret=${applicationSecret}`, getAssistantApiUrl());
}